export default [
  {
    text: 'Teilnahme an der internationalen wissenschaftlichen Konferenz <a href="https://openreadings.eu/">OpenReadings</a> in Vilnius.',
    year: '2026',
  },
  {
    text: 'Mitgliedschaft am <a href="https://home.cern/about/who-we-are/our-governance">CERN</a> im Sommer 2024.',
    year: '2024',
  },
  { text: 'Acert B2 Englisch-Zertifikat', year: '2024' },
  {
    text: 'Stipendium im Rahmen des <a href="https://www.stypendia-pomostowe.pl">Brückenstipendien</a>-Programms.',
    year: '2023',
  },
  {
    text: 'Erneutes Stipendium im Rahmen des Programms <a href="https://www.podparpackie.edu.pl">Stipendienförderung für begabte Schüler</a>.',
    year: '2022',
  },
  {
    text: 'Das Projekt <a href="https://soulgraphy.me">Soulgraphy</a> erreichte 100.000 Aufrufe im Internet.',
    year: '2021',
  },
  {
    text: 'Stipendium im Rahmen des Programms <a href="https://www.podparpackie.edu.pl">Stipendienförderung für begabte Schüler</a>.',
    year: '2020',
  },
  {
    text: 'Preisträger des landesweiten Physikwettbewerbs „Albus“ (8. Platz).',
    year: '2019',
  },
  { text: 'Preisträger des regionalen Physikwettbewerbs.', year: '2019' },
  {
    text: 'Doppelter Preisträger beim landesweiten Wettbewerb „Olimpus“ in Mathematik (5. Platz) und Physik (9. Platz).',
    year: '2019',
  },
]
